import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AcceptedAgreements, Agreement, ClientInfoFormData } from './agreement.domain';
import { AgreementType } from './agreement-type.enum';
import { ConsolidatedAgreementsRestService } from './consolidated-agreements-rest.service';
import { AgreementsService } from './agreements.service';

@Injectable()
export class ConsolidatedAgreementsService {

  constructor(private consolidatedAgreementsRestService: ConsolidatedAgreementsRestService,
              private agreementsService: AgreementsService) {
  }

  saveAgreements(acceptedAgreements: AcceptedAgreements): Observable<void> {
    const agreements = this.getSavingAgreementRequest(acceptedAgreements.agreements, acceptedAgreements.clientInfo);
    return this.consolidatedAgreementsRestService.saveAgreements(agreements)
      .pipe(tap((): void => this.agreementsService.syncCachedAgreements(agreements)));
  }

  private getSavingAgreementRequest(agreements: Array<Agreement>, clientInfo: ClientInfoFormData): Array<Agreement> {
    const agreementsInfo: Array<Agreement> = [];
    agreements.map((agreement: Agreement): void => {
      switch (agreement.agreementType) {
        case(AgreementType.CEG):
        case(AgreementType.ME):
          agreementsInfo.push( {
            agreementType: agreement.agreementType,
            agreementStatus: agreement.agreementStatus,
            exchangeSubscriptionData: {}
          });
          break;
        case(AgreementType.AMEX):
        case(AgreementType.NYSE):
          agreementsInfo.push({
            agreementType: agreement.agreementType,
            agreementStatus: agreement.agreementStatus,
            exchangeSubscriptionData: {
              clientName: `${clientInfo.clientLastName},${clientInfo.clientFirstName}`,
              clientAddress: this.combineAddress(clientInfo),
              clientOccupation: clientInfo.clientOccupation,
              clientEmployerNameAddress: clientInfo.clientEmployerNameAddress,
              clientTitlePosition: clientInfo.clientTitlePosition,
              clientEmployerFunction: clientInfo.clientEmployerFunction
            }
          });
          break;
        case(AgreementType.NASDAQ):
          agreementsInfo.push({
            agreementType: agreement.agreementType,
            agreementStatus: agreement.agreementStatus,
            exchangeSubscriptionData: {
              clientName: `${clientInfo.clientLastName},${clientInfo.clientFirstName}`,
              signature: clientInfo.signature,
              professionalIndicator: clientInfo.professionalIndicator,
              titles: clientInfo.titles,
              agentName: clientInfo.agentName,
              subscriberAgentTitle: clientInfo.agentTitle
            }
          });
          break;
        case(AgreementType.OPRA):
          agreementsInfo.push({
            agreementType: agreement.agreementType,
            agreementStatus: agreement.agreementStatus,
            exchangeSubscriptionData: {
              clientFirstName: clientInfo.clientFirstName,
              clientLastName: clientInfo.clientLastName,
              addressLine1: clientInfo.clientAddress,
              city: clientInfo.city,
              provinceState: clientInfo.provinceState,
              postalCode: clientInfo.postalCode
            }
          });
          break;
        case(AgreementType.LSEGRU):
        case(AgreementType.CMSPDJ):
          agreementsInfo.push({
            agreementType: agreement.agreementType,
            agreementStatus: agreement.agreementStatus,
            exchangeSubscriptionData: {
              clientFirstName: clientInfo.clientFirstName,
              clientLastName: clientInfo.clientLastName,
              clientAddress: clientInfo.clientAddress,
              city: clientInfo.city,
              provinceState: clientInfo.provinceState,
              postalCode: clientInfo.postalCode
            }
          });
          break;
        case(AgreementType.USOTC):
          agreementsInfo.push({
            agreementType: agreement.agreementType,
            agreementStatus: agreement.agreementStatus,
            exchangeSubscriptionData: {
              clientFirstName: clientInfo.clientFirstName,
              clientLastName: clientInfo.clientLastName,
              clientAddress: clientInfo.clientAddress,
              city: clientInfo.city,
              provinceState: clientInfo.provinceState,
              postalCode: clientInfo.postalCode,
              clientOccupation: clientInfo.clientOccupation,
              clientTitlePosition: clientInfo.clientTitlePosition,
              professionalIndicator: clientInfo.professionalIndicator
            }
          });
          break;
        default:
          agreementsInfo.push();
          break;
      }
    });
    return agreementsInfo;
  }

  private combineAddress(clientInfo: ClientInfoFormData): string {
    const combinedAddress = [clientInfo.clientAddress,  clientInfo.city,
      clientInfo.provinceState, clientInfo.postalCode].join(',');
    return combinedAddress.length > 100 ? combinedAddress.substring(0, 99) : combinedAddress;
  }
}
